import { CChartBar } from '@coreui/react-chartjs'
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react-pro'
import React from 'react'
import Loader from 'src/components/Loader'
import useChartData from './useChartData'

const BarChart = () => {
  const {
    loading,
    formattedScData,
    formattedHwData,
    formattedAwsData,
    formattedAlData,
    formattedHlData,
    formattedSswData,
    formattedSslsData,
    formattedOwtData,
    formattedBwmData,
    formattedBlmData,
    formattedFpData,
  } = useChartData()

  return loading ? (
    <Loader />
  ) : (
    <CRow>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Score</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedScData} labels="Score Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Home Win</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedHwData} labels="Home Win Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Away Win</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedAwsData} labels="Away Win Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Away Loss</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedAlData} labels="Away Loss Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Home Loss</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedHlData} labels="Home Loss Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Single Score Win</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedSswData} labels="Single Score Win Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Single Score Loss</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedSslsData} labels="Single Score Loss" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Penalty Miss</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedOwtData} labels="Passes Intercepted Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Only Winner in Team</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedBwmData} labels="Only Winner in Team Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Biggest Win Margin</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedBlmData} labels="Biggest Win Margin Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md={6}>
        <CCard className="mb-4">
          <CCardHeader>Fantasy Points</CCardHeader>
          <CCardBody>
            <CCardBody>
              <CChartBar data={formattedFpData} labels="Fantasy Range" />
            </CCardBody>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default BarChart
